<template>
    <div class="presentations" v-if="data">
        <div class="row" v-if="data.items && data.items.length">
            <z-report-block
                class="col-default-4 col-v-tablet-6 col-mobile-12"
                v-for="(item, index) in data.items"
                :key="index"
                :image="item.preview.link"
                :link="item.file.link"
                :title="item.name"
                :title-period="item.year.value"
                landscape-mode
            />
        </div>

        <z-accordion v-if="data.groups && data.groups.length" class="u-top-margin--xl-important">
            <z-accordion-item
                v-for="(accordion, i) in data.groups"
                :key="i"
                :id="accordion.code"
            >
                <template v-slot:header>
                    <span>{{ accordion.name }}</span>
                </template>
                <template v-slot:body>
                    <div class="row">
                        <z-report-block
                            class="col-default-4 col-v-tablet-6 col-mobile-12"
                            v-for="(item, index) in accordion.items"
                            :key="index"
                            :image="item.preview.link"
                            :link="item.file.link"
                            :title="item.name"
                            :title-period="item.year.value"
                            landscape-mode
                        />
                    </div>
                </template>
            </z-accordion-item>
        </z-accordion>
    </div>
</template>

<script>
export default {
    name: 'presentations',
    data () {
        return {
            data: this.$root.app.components['investors-presentations']
        }
    }
}
</script>
